
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Keystats = dynamic(() => import('features/pro-tools/Keystats'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function KeystatsPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Keystats Tools"
        description="Tangkap peluang pasar lebih cepat dengan ringkasan kinerja emiten yang disajikan dengan menarik. Kamu akan mendapatkan informasi seperti valuasi perusahaan, arus kas, level hutang, dan dividen."
        url={`${siteUrl}/info/pro-tools/keystats`}
      />
      <Keystats />
    </HomePageLayout>
  );
}

export default KeystatsPage;
